import { SeatType } from '@vista-digital/ocapi-types/v1';
import { OccSeatingLegendItemType } from '../../../context/occ/types/config/seating/legend-item-type';
export const getUsedSeatAppearanceRules = (seatingData, seatAppearanceRuleMap) => {
    const { seatLayout, friendSeatIds, seatSelectionLimits } = seatingData;
    const usedRuleIds = new Set();
    seatLayout.areas.forEach(area => {
        var _a;
        // skip legend items for areas which the user cannot currently select
        const areaCategoryLimit = (_a = seatSelectionLimits.limitsPerAreaCategory) === null || _a === void 0 ? void 0 : _a[area.areaCategoryId];
        if ((areaCategoryLimit === null || areaCategoryLimit === void 0 ? void 0 : areaCategoryLimit.max) === 0) {
            return;
        }
        // iterate through seats to find used seat types + seat appearance rules
        area.rows.forEach(row => {
            row.seats.forEach(seat => {
                const seatAppearanceRule = seatAppearanceRuleMap.get(seat.id);
                if (seatAppearanceRule) {
                    usedRuleIds.add(seatAppearanceRule.id);
                }
                else {
                    const legendItemType = getLegendItemTypeForSeatType(seat.type);
                    if (legendItemType) {
                        usedRuleIds.add(legendItemType);
                    }
                }
            });
        });
    });
    if (friendSeatIds && friendSeatIds.length >= 1) {
        usedRuleIds.add(OccSeatingLegendItemType.Friend);
    }
    return usedRuleIds;
};
function getLegendItemTypeForSeatType(seatType) {
    switch (seatType) {
        case SeatType.Normal:
            return OccSeatingLegendItemType.Normal;
        case SeatType.SofaLeft:
        case SeatType.SofaRight:
        case SeatType.SofaMiddle:
            return OccSeatingLegendItemType.Sofa;
        case SeatType.Wheelchair:
            return OccSeatingLegendItemType.Wheelchair;
        case SeatType.Companion:
            return OccSeatingLegendItemType.Companion;
        default:
            return;
    }
}
//# sourceMappingURL=get-used-seat-appearance-rules.js.map